import { defineStore } from 'pinia';
import { IUserSearchData, ICreateUserCredentials, ICredentials } from '@/types/interfaces';

export type RegisterState = {
  searchUser: IUserSearchData;
  createUser: ICreateUserCredentials;
  credentials: ICredentials;
  phoneNumberCode: string;
  phoneNumber: string;
}

export const useRegistrationStore = defineStore({
  id: 'registrationStore',

  state: () => ({
    searchUser: {},
    createUser: {},
    credentials: {},
    phoneNumberCode: '',
    phoneNumber: '',
  } as RegisterState),

  actions: {
    resetRegistration(): void {
      this.searchUser = {} as IUserSearchData;
      this.createUser = {} as ICreateUserCredentials;
      this.credentials = {} as ICredentials;
      this.phoneNumberCode = '';
      this.phoneNumber = '';
    },
  },
});
